import type { GeoJSON } from "geojson";

export const parseGeometry = (geometry: unknown | null): GeoJSON | null => {
  if (!geometry) {
    return null;
  }
  if (typeof geometry !== "object") {
    return null;
  }
  if (!("type" in geometry)) {
    return null;
  }

  try {
    const geoJson = geometry as GeoJSON;
    if (isSupportedGeoJSON(geoJson)) {
      return geoJson;
    }
    return null;
  } catch {
    return null;
  }
};

const isSupportedGeoJSON = (geoJson: GeoJSON): boolean =>
  geoJson.type === "Point" ||
  geoJson.type === "MultiPoint" ||
  geoJson.type === "LineString" ||
  geoJson.type === "MultiLineString" ||
  geoJson.type === "Polygon" ||
  geoJson.type === "MultiPolygon" ||
  geoJson.type === "GeometryCollection" ||
  geoJson.type === "FeatureCollection";
